import { FeatureFlagsService } from '../FeatureFlagsService';

/**
 * Creates a feature flags provider
 * @returns The feature flags provider
 */
export function createFeatureFlagsProvider() {
  return {
    isFeatureFlagEnabled: async (flagName: string): Promise<boolean> => {
      const featureFlagsService = new FeatureFlagsService();
      const flag = await featureFlagsService.getFeatureFlag(flagName);
      return flag?.enabled ?? false;
    },
  };
}
